import React from "react";
import { Header } from "../common/components/Header";
import { Card } from "../common/components/Card";
import { CommonPageTemplate } from "../common/components/CommonPageTemplate";
import { MdOutlineVideogameAsset, MdOutlineDraw } from "react-icons/md";
import { LiaLaptopCodeSolid } from "react-icons/lia";
import { SiInteractiondesignfoundation } from "react-icons/si";


import about from "../data/about.json";

const galleryImages = (() => {
  const imageContext = (require as any).context(
    "../common/assets/image/life-in-motion",
    false,
    /\.(png|jpe?g)$/i
  );

  return imageContext.keys().map((key: string, index: number) => ({
    src: imageContext(key) as string,
    alt: `Life in motion image ${index + 1}`,
  }));
})();

export const About = () => {
  const icon = [
    SiInteractiondesignfoundation,
    LiaLaptopCodeSolid,
    MdOutlineDraw,
    MdOutlineVideogameAsset,
  ];
  const imageRow = [...galleryImages, ...galleryImages];

  return (
    <CommonPageTemplate
      articleTitle="About me"
      articleClassName="about"
      isActive={true}
    >
      <section className="about-text">
        <p className="about-intro">{about.aboutMeOne}</p>
        <p>{about.aboutMeTwo}</p>
          <p>{about.aboutMeThree}</p>
          <p>{about.aboutMeFour}</p>
          <p>{about.aboutMeFive}</p>
      </section>
      {/*
- service
*/}
      <section className="service">
        <Header
          headerTitle="What i'm doing"
          headerElementName="h3"
          headerClassName="service-title"
        />
        <ul className="service-list">
          {about.whatIDo.map((item, i) => {
            const Icon = icon[i];
            return (
              <li className="service-item" key={item.uId}>
                <Card
                  description={item.description}
                  icon={<Icon size="42" />}
                  cardTitle={item.title}
                  headerClassName="service-item-title"
                  headerElementName="h4"
                />
              </li>
            );
          })}
        </ul>
      </section>

      <section className="about-gallery" aria-label="Life in motion gallery">
        <Header
          headerTitle="Life in Motion, Beyond Design"
          headerElementName="h3"
          headerClassName="about-gallery-title"
        />
        <div className="about-gallery-track">
          {imageRow.map((image, index) => (
            <figure className="about-gallery-item" key={`${image.alt}-${index}`}>
              <img src={image.src} alt={image.alt} />
            </figure>
          ))}
        </div>
      </section>
    </CommonPageTemplate>
  );
};
